import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Logo } from '@plone/volto/components';
import { useSelector } from 'react-redux';

const Footer = ({ intl }) => {
    const user = useSelector((state) =>
        state.userSession.token,
    );

    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className='footerBottom'>
                <div className='logo'>
                    <Logo />
                </div>
                <div className='outerFooterList'>
                    <List className="footerList">
                        {user != null &&
                            <div role="listitem" className="item">
                                <a className="item" href="./intranet">
                                    <FormattedMessage
                                        id='Footer-Intranet'
                                        defaultMessage="Vereinsinternes"
                                    />
                                </a>
                            </div>
                        }

                        <div role="listitem" className="item">
                            <a className="item" href="./vorstand">
                                <FormattedMessage
                                    id='Footer-Contact'
                                    defaultMessage="Kontakt"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="SVPK Seeland"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);